
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/appliance-repair",
      function () {
        return require("private-next-pages/services/appliance-repair/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/appliance-repair"])
      });
    }
  